module.exports = __webpack_public_path__ + "static/img/icon_play2.5def56c2.png";